// @flow

import * as React from 'react';

import type { DomainProduct } from '@gandi/cart';
import type { Organization } from '@gandi/redux-organization';
import { Base } from '@gandi/ui';

import { selectSmd } from 'src/Tmch/modules/selector';
import { useAppSelector } from 'src/hooks/useAppSelector';
import type { SMD } from 'src/types';

import FileForm from './FileForm';
import InputPills from './InputPills';

type Props = {
  checking: boolean,
  setupOwnerOrga: Organization,
  product: DomainProduct,
  setSelectedSmdId: string => void,
  setChecking: boolean => void,
  removedByUser: boolean,
  setRemovedByUser: boolean => void,
};

export default function InputContainer({
  setupOwnerOrga,
  checking,
  product,
  setSelectedSmdId,
  setChecking,
  removedByUser,
  setRemovedByUser,
}: Props): React.Node {
  const smdEntries: Array<SMD> = useAppSelector(selectSmd);

  return (
    <Base marginBottom="base" className="wrapper-plain">
      {smdEntries.length === 0 && (
        <FileForm
          checking={checking}
          product={product}
          setChecking={setChecking}
          removedByUser={removedByUser}
          setRemovedByUser={setRemovedByUser}
        />
      )}
      {smdEntries.length > 0 && (
        <InputPills
          setupOwnerOrga={setupOwnerOrga}
          product={product}
          checking={checking}
          setSelectedSmdId={setSelectedSmdId}
          setChecking={setChecking}
          removedByUser={removedByUser}
          setRemovedByUser={setRemovedByUser}
        />
      )}
    </Base>
  );
}
